import { ArdDateInputDeserializeFn, ArdDateInputSerializeFn } from '@ardium-ui/ui';
import { format, parse } from 'date-fns';

/**
 * Serializes a {@link Date} to `dd.MM.yyyy` string format used by date inputs.
 */
export const DATE_SERIALIZATION_FN: ArdDateInputSerializeFn<Date> = date => (date ? format(date, `dd.MM.yyyy`) : '');

/**
 * Deserializes a `dd.MM.yyyy` formatted string into a {@link Date}.
 * Returns `null` when the string does not match the expected pattern.
 */
export const DATE_DESERIALIZATION_FN: ArdDateInputDeserializeFn<Date> = dateString =>
  /^\d\d\.\d\d\.\d\d\d\d$/.test(dateString) ? parse(dateString, `dd.MM.yyyy`, new Date()) : null;

export function toDateOnlyString(value: Date | string): string {
  if (typeof value === 'string') return value.slice(0, 10);
  return value.toISOString().slice(0, 10);
}

export function toLocalDateOnlyTime(value: Date | string): number {
  if (typeof value === 'string') {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (match) {
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])).getTime();
    }
  }

  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
}
